import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import useAnalytics from 'services/hooks/analytics';
import { events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';

const UpgradeButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { track } = useAnalytics();

  const handleUpgradeClick = () => {
    track(
      events.upgradeSubscription(
        'download_modal',
        AnalyticsEventLocation.ACCOUNT_YOUTUBE_CHANNEL
      )
    );
    navigate(locations.subscription.pricing.pathname(''));
  };

  return (
    <Button onClick={handleUpgradeClick} variant="outlined">
      {t('account:youtubeChannel:upgradeContainer:upgrade')}
    </Button>
  );
};

export default UpgradeButton;
